import { InactivityTracker } from 'hb-react/shared/utils/InactivityPublisher/trackers/InactivityTracker';

export class TabVisibilityTracker extends InactivityTracker {
  constructor(timeoutMS: number) {
    super(timeoutMS);

    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  public init(onTrackerChange: () => void) {
    super.init(onTrackerChange);

    this.handleVisibilityChange();

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  public destroy() {
    super.destroy();

    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
    );
  }

  private handleVisibilityChange() {
    clearTimeout(this.timeoutId);

    const tabVisible = !document.hidden;

    if (tabVisible) {
      this.clearInactivityTimeout();
    } else {
      this.startInactivityTimeout();
    }
  }
}
